export default {
  backup: 'Sauvegarde',
  downloadTheProjectBackupFile: 'Téléchargez le fichier de sauvegarde du projet (en json)',
  restoreProject: 'Restaurer...',
  incorrectUsrPwd: 'Identifiant ou mot de passe incorrect',
  askDeleteUser: 'Voulez-vous vraiment supprimer cet utilisateur ?',
  askDeleteTemp: 'Voulez-vous vraiment supprimer ce modèle ?',
  askDeleteEnv: 'Voulez-vous vraiment supprimer cet environnement ?',
  askDeleteInv: 'Voulez-vous vraiment supprimer cet inventeur ?',
  askDeleteKey: 'Voulez-vous vraiment supprimer cette clé ?',
  askDeleteRepo: 'Voulez-vous vraiment supprimer ce dépôt ?',
  askDeleteProj: 'Voulez-vous vraiment supprimer ce projet ?',
  askDeleteTMem: 'Voulez-vous vraiment supprimer ce membre de l\'équipe ?',
  edit: 'Modifier',
  nnew: 'Nouveau',
  keyFormSshKey: 'Clé SSH',
  keyFormLoginPassword: 'Connectez-vous avec mot de passe',
  keyFormNone: 'Aucune',
  incorrectUrl: 'URL incorrecte',
  username: 'Nom d\'utilisateur',
  username_required: 'Le nom d\'utilisateur est requis',
  dashboard: 'Tableau de bord',
  history: 'Historique',
  activity: 'Activité',
  settings: 'Paramètres',
  signIn: 'Se connecter',
  password: 'Mot de passe',
  changePassword: 'Changer le mot de passe',
  editUser: 'Modifier l\'utilisateur',
  newProject: 'Nouveau projet',
  close: 'Fermer',
  newProject2: 'Nouveau projet...',
  demoMode: 'MODE DE DÉMONSTRATION',
  task: 'Tâche n°{expr}',
  youCanRunAnyTasks: 'Vous pouvez exécuter n\'importe quelle tâche',
  youHaveReadonlyAccess: 'Vous avez un accès en lecture seule',
  taskTemplates: 'Modèles de tâches',
  inventory: 'Inventaire',
  environment: 'Environnement',
  keyStore: 'Magasin de clés',
  repositories: 'Dépôts',
  darkMode: 'Mode sombre',
  team: 'Équipe',
  users: 'Utilisateurs',
  editAccount: 'Modifier le compte',
  signOut: 'Déconnexion',
  error: 'Erreur',
  refreshPage: 'Actualiser la page',
  relogin: 'Se reconnecter',
  howToFixSigninIssues: 'Comment résoudre les problèmes de connexion',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Tout d\'abord, vous avez besoin d\'accéder au serveur où Semaphore est en cours d\'exécution.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Exécutez la commande suivante sur le serveur pour voir les utilisateurs existants :',
  semaphoreUserList: 'liste d\'utilisateurs Semaphore',
  youCanChangePasswordOfExistingUser: 'Vous pouvez changer le mot de passe de l\'utilisateur existant :',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Ou créer un nouvel utilisateur administrateur :',
  close2: 'Fermer',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: 'Vous n\'avez pas de compte ou vous ne pouvez pas vous connecter ?',
  password2: 'Mot de passe',
  cancel: 'Annuler',
  noViews: 'Aucune vue',
  addView: 'Ajouter une vue',
  editEnvironment: 'Modifier l\'environnement',
  deleteEnvironment: 'Supprimer l\'environnement',
  environment2: 'Environnement',
  newEnvironment: 'Nouvel environnement',
  environmentName: 'Nom de l\'environnement',
  extraVariables: 'Variables supplémentaires',
  enterExtraVariablesJson: 'Saisissez JSON pour les variables supplémentaires...',
  environmentVariables: 'Variables d\'environnement',
  enterEnvJson: 'Saisissez JSON pour l\'environnement...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'L\'environnement et les variables supplémentaires doivent être un JSON valide. Exemple :',
  dashboard2: 'Tableau de bord',
  ansibleSemaphore: 'Semaphore Ansible',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: 'Nous sommes désolés, mais <%= htmlWebpackPlugin.options.title %> ne fonctionne pas correctement sans JavaScript. Veuillez l\'activer pour continuer.',
  deleteInventory: 'Supprimer l\'inventaire',
  newInventory: 'Nouvel inventaire',
  name: 'Nom',
  userCredentials: 'Identifiants utilisateur',
  sudoCredentialsOptional: 'Identifiants Sudo (facultatif)',
  type: 'Type',
  pathToInventoryFile: 'Chemin vers le fichier d\'inventaire',
  enterInventory: 'Entrer l\'inventaire...',
  staticInventoryExample: 'Exemple d\'inventaire statique:',
  staticYamlInventoryExample: 'Exemple d\'inventaire YAML statique:',
  keyName: 'Nom de la clé',
  loginOptional: 'Connexion (facultatif)',
  usernameOptional: 'Nom d\'utilisateur (facultatif)',
  privateKey: 'Clé privée',
  override: 'Remplacer',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Utilisez ce type de clé pour les référentiels HTTPS et pour les playbooks qui utilisent des connexions non-SSH.',
  deleteKey: 'Supprimer la clé',
  newKey: 'Nouvelle clé',
  create: 'Créer',
  newTask: 'Nouvelle tâche',
  cantDeleteThe: 'Impossible de supprimer {objectTitle}',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: 'Le {objectTitle} ne peut pas être supprimé car il est utilisé par les ressources ci-dessous',
  projectName: 'Nom du projet',
  allowAlertsForThisProject: 'Autoriser les alertes pour ce projet',
  telegramChatIdOptional: 'Identifiant de chat Telegram (facultatif)',
  maxNumberOfParallelTasksOptional: 'Nombre maximal de tâches en parallèle (facultatif)',
  deleteRepository: 'Supprimer le référentiel',
  newRepository: 'Nouveau référentiel',
  urlOrPath: 'URL ou chemin',
  absPath: 'chemin absolu',
  branch: 'Branche',
  accessKey: 'Clé d\'accès',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Identifiants pour accéder au référentiel Git. Il doit être :',
  ifYouUseGitOrSshUrl: 'si vous utilisez une URL Git ou SSH.',
  ifYouUseHttpsOrFileUrl: 'si vous utilisez une URL HTTPS ou fichier.',
  none: 'Aucun',
  ssh: 'SSH',
  deleteProject: 'Supprimer le projet',
  save: 'Enregistrer',
  deleteProject2: 'Supprimer le projet',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'Une fois que vous avez supprimé un projet, il n\'y a pas de retour en arrière possible. Veuillez être certain.',
  name2: 'Nom *',
  title: 'Titre *',
  description: 'Description',
  required: 'Requis',
  key: '{expr}',
  surveyVariables: 'Variables d\'enquête',
  addVariable: 'Ajouter une variable',
  columns: 'Colonnes',
  buildVersion: 'Version de construction',
  messageOptional: 'Message (facultatif)',
  debug: 'Debug',
  dryRun: 'Simulation',
  diff: 'Différence',
  advanced: 'Avancé',
  hide: 'Cacher',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'Veuillez autoriser le remplacement de l\'argument CLI dans les paramètres du modèle de tâche',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'Arguments CLI (tableau JSON). Exemple: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Démarré',
  author: 'Auteur',
  duration: 'Durée',
  stop: 'Arrêter',
  deleteTeamMember: 'Supprimer un membre de l\'équipe',
  team2: 'Équipe',
  newTeamMember: 'Nouveau membre de l\'équipe',
  user: 'Utilisateur',
  administrator: 'Administrateur',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Définit la version de départ de votre artefact. Chaque exécution incrémente la version de l\'artefact.',
  forMoreInformationAboutBuildingSeeThe: 'Pour plus d\'informations sur la construction, voir la',
  taskTemplateReference: 'Référence du modèle de tâche',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Définit l\'artefact qui doit être déployé lorsque la tâche est exécutée.',
  forMoreInformationAboutDeployingSeeThe: 'Pour plus d\'informations sur le déploiement, voir la',
  taskTemplateReference2: 'Référence du modèle de tâche',
  definesAutorunSchedule: 'Définit le calendrier d\'exécution automatique.',
  forMoreInformationAboutCronSeeThe: 'Pour plus d\'informations sur Cron, voir la',
  cronExpressionFormatReference: 'Référence du format d\'expression Cron',
  startVersion: 'Version de départ',
  example000: 'Exemple: 0.0.0',
  buildTemplate: 'Modèle de construction',
  autorun: 'Exécution automatique',
  playbookFilename: 'Nom de fichier du playbook *',
  exampleSiteyml: 'Exemple: site.yml',
  inventory2: 'Inventaire *',
  repository: 'Dépôt',
  environment3: 'Environnement *',
  vaultPassword: 'Mot de passe du coffre-fort',
  vaultPassword2: 'Mot de passe du coffre-fort',
  view: 'Vue',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Je veux exécuter une tâche avec le cron uniquement pour les nouveaux commits d\'un dépôt spécifique',
  repository2: 'Dépôt',
  cronChecksNewCommitBeforeRun: 'Cron vérifie les nouveaux commits avant l\'exécution',
  readThe: 'Lire la',
  toLearnMoreAboutCron: 'pour en savoir plus sur Cron.',
  suppressSuccessAlerts: 'Supprimer les alertes de réussite',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'Arguments CLI (tableau JSON). Exemple: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'Autoriser les arguments CLI dans la tâche',
  docs: 'docs',
  editViews: 'Modifier les vues',
  newTemplate: 'Nouveau modèle',
  taskTemplates2: 'Modèles de tâches',
  all: 'Tous',
  notLaunched: 'Non lancé',
  by: 'par {user_name}',
  editTemplate: 'Modifier le modèle',
  newTemplate2: 'Nouveau modèle',
  deleteTemplate: 'Supprimer le modèle',
  playbook: 'Playbook',
  email: 'Email',
  adminUser: 'Utilisateur admin',
  sendAlerts: 'Envoyer des alertes',
  deleteUser: 'Supprimer l\'utilisateur',
  newUser: 'Nouvel utilisateur',
  re: 'Re{getActionButtonTitle}',
  teamMember: '{expr} Membre de l\'équipe',
  taskId: 'ID de tâche',
  version: 'Version',
  status: 'Statut',
  start: 'Début',
  actions: 'Actions',
  alert: 'Alerte',
  admin: 'Administrateur',
  role: 'Rôle',
  external: 'Externe',
  time: 'Temps',
  path: 'Chemin',
  gitUrl: 'URL Git',
  sshKey: 'Clé SSH',
  lastTask: 'Dernière tâche',
  task2: 'Tâche',
  add: 'Ajouter',
  password_required: 'Le mot de passe est requis',
  name_required: 'Le nom est requis',
  user_credentials_required: 'Les informations d\'identification de l\'utilisateur sont requises',
  type_required: 'Le type est requis',
  path_required: 'Le chemin vers le fichier d\'inventaire est requis',
  private_key_required: 'La clé privée est requise',
  project_name_required: 'Le nom du projet est requis',
  repository_required: 'Le dépôt est requis',
  branch_required: 'La branche est requise',
  key_required: 'La clé est requise',
  user_required: 'L\'utilisateur est requis',
  build_version_required: 'La version de construction est requise',
  title_required: 'Le titre est requis',
  isRequired: 'est requis',
  mustBeInteger: 'Doit être un entier',
  mustBe0OrGreater: 'Doit être égal à 0 ou supérieur',
  start_version_required: 'La version de départ est requise',
  playbook_filename_required: 'Le nom de fichier du playbook est requis',
  inventory_required: 'L\'inventaire est requis',
  environment_required: 'L\'environnement est requis',
  email_required: 'L\'adresse e-mail est requise',
  build_template_required: 'Le modèle de construction est requis',
  Task: 'Tâche',
  Build: 'Construire',
  Deploy: 'Déployer',
  Run: 'Exécuter',
};
